module.exports = __webpack_public_path__ + "static/ring_of_invisibility-cd001b6bf2ea56208b29ab6aba44202b.jpeg";